import { render, staticRenderFns } from "./RiskMatrixReportConfigurationsBefore.vue?vue&type=template&id=42a82d16&scoped=true&"
import script from "./RiskMatrixReportConfigurationsBefore.vue?vue&type=script&lang=js&"
export * from "./RiskMatrixReportConfigurationsBefore.vue?vue&type=script&lang=js&"
import style0 from "./RiskMatrixReportConfigurationsBefore.vue?vue&type=style&index=0&id=42a82d16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a82d16",
  null
  
)

export default component.exports